import React from 'react';

function Button(props) {
  const {className, loading, buttonId, disabled} = props;
  const newProps = {...props};
  delete newProps.className;
  delete newProps.loading;
  delete newProps.buttonId;
  delete newProps.disabled;

  return (
    <button
      {...newProps}
      id={buttonId && `button-${buttonId}`}
      disabled={(disabled || loading) && true}
      className={`p-4 h-fit rounded-md transition ease-in-out bg-wwLight ${
        loading || disabled ? 'opacity-50' : ''
      } text-white font-semibold ${
        !loading && !disabled ? 'hover:bg-secondary' : ''
      } border active:border-black active:bg-transparent ${className}`}
    >
      {(props.loading && props.loadingtext) || props.children}
    </button>
  );
}

export default Button;
